import { useEffect, useState } from 'react';
import { lastDriverPosition } from 'redux/modules/journeys/http';

import driverIcon from './icons/driver.png';

import { getIcon, getMiddlePosition } from './utils';

export const useAssignedDriverMarker = (driver, setWarning) => {
  const [assignedDriverMarker, setAssignedDriverMarker] = useState(null);

  const { user_set = [], is_static } = driver || {};
  const [user] = user_set || [];

  useEffect(() => {
    const fetchDriverPosition = async () => {
      try {
        if (!user) {
          return;
        }
        const res = await lastDriverPosition(user && user.id);

        const { data } = res || {};

        const [position] = data || [];

        setAssignedDriverMarker({
          icon: {
            url: driverIcon,
            size: new window.google.maps.Size(24, 24),
            scaledSize: new window.google.maps.Size(24, 24),
          },
          position: {
            lat: position.latitude,
            lng: position.longitude,
          },
          zIndex: 2,
          clickable: false,
          accuratePosition: position.location_mode === 'hard',
          dispatcher: !!is_static,
        });
      } catch (e) {
        setWarning('NO_DRIVER_GPS');
        console.log('error: ', e);
      }
    };

    fetchDriverPosition();
  }, [setAssignedDriverMarker, user, driver, setWarning, is_static]);

  return { assignedDriverMarker };
};

export const useStopMarkers = ({ stops = [], shipper_orders_skin, colorSchema }) => {
  const [stopMarkers, setStopMarkers] = useState([]);

  useEffect(() => {
    if (!window.google) {
      return;
    }
    const markers = stops.map(
      ({ shipment_state_logs, status, address, shipper_order_id }, key) => ({
        icon: {
          ...getIcon({
            address,
            status,
            shipper_order_id,
            shipper_orders_skin,
            colorSchema,
          }),
          size: new window.google.maps.Size(20, 20),
          scaledSize: new window.google.maps.Size(20, 20),
        },
        position: {
          lat: address.latitude,
          lng: address.longitude,
        },
        zIndex: 2,
        clickable: false,
        status,
        shipment_state_logs,
      })
    );

    setStopMarkers(markers);
  }, [stops, shipper_orders_skin, colorSchema]);

  return stopMarkers;
};

export const useDriverRouteInfoMarker = (driverDirections) => {
  if (!driverDirections?.routes?.length) {
    return null;
  }

  const position = getMiddlePosition(driverDirections);

  if (typeof position?.lat !== 'number' || typeof position?.lng !== 'number') {
    return null;
  }

  return {
    labelStyle: {
      minHeight: '40px',
      minWidth: '50px',
      backgroundColor: 'black',
      fontSize: '12px',
      fontWeight: '300',
      padding: '2px',
      color: 'white',
      opacity: '1',
      clipPath: 'polygon(0% 0%, 100% 0%, 98% 84%, 66% 84%, 50% 99%, 36% 84%, 0 84%)',
    },
    icon: ' ',
    position,
    zIndex: 2,
    labelAnchor: new window.google.maps.Point(25, 40),
  };
};
